import { z } from "zod";
export const ZDateish = z.union([z.date(), z.string().datetime()]);
